module.exports = __webpack_public_path__ + "static/media/finished-glowing.6fffb137.png";